<div class="layout-grid">
    <app-navbar class="navbar" [isMobile]="isMobile" (sidebarToggle)="toggleSidebar()"></app-navbar>
    @if (isMobile && sidebarOpened) {
    <div class="sidebar-backdrop" (click)="closeSidebar()"></div>
    }
    <app-sidebar
        class="sidebar"
        [class.mobile-open]="isMobile && sidebarOpened"
        [class.mobile-closed]="isMobile && !sidebarOpened"
        [opened]="sidebarOpened"
        [isMobile]="isMobile"
        (closeSidebar)="closeSidebar()"
    ></app-sidebar>
    <main class="bg-gray-100 main">
        <router-outlet></router-outlet>
    </main>
    <app-modal></app-modal>
    <app-toast></app-toast>
</div>
